import MemberRegisterModel from './MemberRegisterModel';
import ObjectToFormData from '../../../../Src/Utils/Object/ObjectToFormData';
import { clone } from '../../../../Src/Utils/Json';
import BloodDonorModelRequestResolver
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/BloodDonorModelResolver/BloodDonorModelRequestResolver';
import { isObjectEmpty } from '../../../../Src/Utils/Object';
import moment from 'moment';
import { pick } from 'lodash/object';
import IsCyrillic from '../../../../Src/Utils/Validation/IsCyrillic';

export default {
    data() {
        return {
            memberRegisterModel: clone(MemberRegisterModel),
            memberRegisterModelError: {},
            bloodDonorFormLoader: false,
        };
    },
    methods: {
        async onSaveBloodDonorEvent() {
            this.message = null;
            this.bloodDonorFormLoader = true;
            this.memberRegisterModelError = {};

            try {
                const resolvedModel = BloodDonorModelRequestResolver(this.memberRegisterModel);

                const modelErrors = this.cyrillicAlphabetCheck(resolvedModel);

                if (!isObjectEmpty(modelErrors)) {
                    this.memberRegisterModelError = modelErrors;
                    this.agreed = false;
                    this.continueToNextStage = false;
                    this.bloodDonorFormLoader = false;

                    return;
                }

                const response = await window.axios.post(
                    `/members/register`,
                    ObjectToFormData(resolvedModel),
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                const { status, message } = response.data;

                this.$toastResponse(message, status);

                if (!!status) {
                    localStorage.setItem('mrs', 'true');
                    this.$router.redirect(`/members/register`);

                    return;
                }

                this.bloodDonorFormLoader = false;
            } catch (error) {
                this.bloodDonorFormLoader = false;

                this.memberRegisterModelError = this.getResponseErrors(error);

                if (!!this.memberRegisterModelError && !isObjectEmpty(this.memberRegisterModelError)) {
                    this.agreed = false;
                    this.continueToNextStage = false;
                }

                this.$toastException(error);
            }
        },
        onUpdateModelEvent(name, value) {
            Object.assign(this.memberRegisterModel, {
                [name]: value
            });
        },
        onUpdateBirthdate(name, value) {
            const birthdate = value.replaceAll('/', '-');

            this.onUpdateModelEvent(name, birthdate);

            this.memberRegisterModel.password = !!birthdate
                ? moment(birthdate, 'DD-MM-YYYY').format('DDYYYY')
                : null;
        },
        onUpdatePlasmaStatus(name, value) {
            this.onUpdateModelEvent(name, value);

            if (name === 'plasmaBloodDonorStatus' && value !== 'yes') {
                this.onUpdateModelEvent(
                    'plasma_donor_stamps',
                    [],
                );
            }

            if (name === 'plasmaBloodDonorStatus' && value !== 'other') {
                this.onUpdateModelEvent(
                    'plasmaBloodDonorStatusOther',
                    null,
                );
            }
        },
        onUpdateRegionEvent(name, value) {
            this.onUpdateModelEvent(name, value);

            switch (name) {
                case 'region':
                    Object.assign(this.memberRegisterModel, {
                        municipality: null,
                        residence_place: null,
                        otherRegion: null,
                    });
                    break;
                case 'municipality':
                    Object.assign(this.memberRegisterModel, {
                        residence_place: null,
                    });
                    break;
            }
        },
        cyrillicAlphabetCheck(model) {
            let errors = {};

            const modelTmp = pick(
                clone(model),
                [
                    'firstname',
                    'lastname',
                    'regionOther',
                    'municipality',
                    'residence_place',
                    'address',
                    'bloodDonorStatusOther',
                    'plasmaBloodDonorStatusOther',
                    'membershipType',
                    'membershipTypeOther',
                    'associationMembershipTypeOther',
                ]
            );

            for(let item in modelTmp) {
                const value = modelTmp[item];

                if (!!value && !IsCyrillic(value)) {
                    errors[item] = [
                        'Полето мора да биде пополнето со кирилична азбука'
                    ];
                }
            }

            return errors;
        },
    },
}